export default __webpack_public_path__ + "media/images/apple-touch-icon-bd1315cf.png";